import chroma from 'chroma-js';

export const getContrastingTextColor = (backgroundColor) => {
    return backgroundColor && chroma(backgroundColor).luminance() > 0.7
        ? '#263238'
        : '#ffffff';
};
